import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Image3D from './Image3D';

const PhotoModal = (props) => {
    const sources = {
        left: `${props.paths.images}/${props.photo.dir}/L/${props.photo.file}`,
        right: `${props.paths.images}/${props.photo.dir}/R/${props.photo.file}`
    };

    let size = 'lg';
    if (['parallel', 'crosseye'].includes(props.options.type)) {
        size = 'xl';
    }


    return (
        <Modal
            {...props}
            size={size}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton >
                <Modal.Title>
                    #{props.photo.id}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Image3D
                    sources={sources} options={props.options}
                />
            </Modal.Body>
        </Modal>
    );
};

PhotoModal.propTypes = {
    photo: PropTypes.object,
    paths: PropTypes.object,
    options: PropTypes.object
};

export default PhotoModal;
